import type { AddressDto, BenefitDetailDto } from "./benefit-types"

const emptyAddress = (): AddressDto => ({ address: "", city: "", state: "", zipCode: "" })

export interface ApplicationDetailsDraft {
  applicationDate: string
  residential: AddressDto
  mailing: AddressDto
}

export function applicationDetailsDraft(benefit: BenefitDetailDto): ApplicationDetailsDraft {
  return {
    applicationDate: benefit.applicationDate?.slice(0, 10) ?? "",
    residential: { ...(benefit.addresses?.Residential ?? emptyAddress()) },
    mailing: { ...(benefit.addresses?.Mailing ?? emptyAddress()) },
  }
}

export function applicationDetailsRequest(draft: ApplicationDetailsDraft, concurrencyToken: string | null) {
  if (!concurrencyToken) throw new Error("Reload and reopen the application details before saving.")
  if (!/^\d{4}-\d{2}-\d{2}$/.test(draft.applicationDate)) throw new Error("Enter the application date.")
  const normalize = (address: AddressDto) => ({
    address: address.address.trim(), city: address.city.trim(),
    state: address.state.trim().toUpperCase(), zipCode: address.zipCode.trim(),
  })
  return {
    concurrencyToken, applicationDate: draft.applicationDate,
    residential: normalize(draft.residential), mailing: normalize(draft.mailing),
  }
}
